<template>
  <div
    class="stepper-wrapper"
    :class="{
      'inverted-colors': isLightBackground,
      preparing: isPreparing,
      'animate-in': isAnimating,
    }"
  >
    <div
      :class="{ 'stepper-item completed': true }"
      :style="{ '--step-index': 0 }"
    >
      <div class="step-counter">
        <font-awesome-icon :icon="['fas', 'check']" />
      </div>
      <div class="step-name">{{ setName("RESERVADO") }}</div>
    </div>
    <div
      v-if="customerId !== 146"
      :class="{
        'stepper-item': true,
        completed: [
          'PROMESADO',
          'ESCRITURADO',
          'ENTREGADO',
          'POSTVENTA',
        ].includes(apartment.asset_state),
      }"
      :style="{ '--step-index': 1 }"
    >
      <div class="step-counter">
        <font-awesome-icon
          v-if="
            ['PROMESADO', 'ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
              apartment.asset_state
            )
          "
          :icon="['fas', 'check']"
        />
        <font-awesome-icon
          v-else-if="['RESERVADO'].includes(apartment.asset_state)"
          :icon="['far', 'hourglass']"
          class="fa-spin"
          style="--fa-animation-iteration-count: 5"
        />
        <template v-else-if="country == 1">2</template>
      </div>
      <div class="step-name">{{ setName("PROMESADO") }}</div>
    </div>
    <div
      v-if="country == 1"
      :class="{
        'stepper-item': true,
        completed: ['ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
          apartment.asset_state
        ),
      }"
      :style="{ '--step-index': 2 }"
    >
      <div class="step-counter">
        <font-awesome-icon
          v-if="
            ['ESCRITURADO', 'ENTREGADO', 'POSTVENTA'].includes(
              apartment.asset_state
            )
          "
          :icon="['fas', 'check']"
        />
        <font-awesome-icon
          v-else-if="['PROMESADO'].includes(apartment.asset_state)"
          :icon="['far', 'hourglass']"
          class="fa-spin"
          style="--fa-animation-iteration-count: 5"
        />
        <template v-else-if="country == 1">3</template>
      </div>
      <div class="step-name">{{ setName("ESCRITURADO") }}</div>
    </div>
    <div
      :class="{
        'stepper-item': true,
        completed: ['ENTREGADO', 'POSTVENTA'].includes(apartment.asset_state),
      }"
      :style="{ '--step-index': 3 }"
    >
      <div class="step-counter">
        <font-awesome-icon
          v-if="['ENTREGADO', 'POSTVENTA'].includes(apartment.asset_state)"
          :icon="['fas', 'check']"
        />
        <font-awesome-icon
          v-else-if="
            (country == 1
              ? ['ENTREGADO']
              : ['PROMESADO', 'ENTREGADO']
            ).includes(apartment.asset_state)
          "
          :icon="['far', 'hourglass']"
          class="fa-spin"
          style="--fa-animation-iteration-count: 5"
        />
        <template v-else-if="country == 1">4</template>
      </div>
      <div class="step-name">{{ setName("ENTREGADO") }}</div>
    </div>
  </div>
</template>
<script>
export default {
  name: "BuyProgress",
  props: {
    apartment: { default: null },
    country: { default: 1 },
  },
  data() {
    return {
      isPreparing: true,
      isAnimating: false,
    };
  },
  mounted() {
    this.triggerAnimation();
  },
  watch: {
    apartment: {
      handler() {
        this.triggerAnimation();
      },
      deep: true,
    },
  },
  methods: {
    triggerAnimation() {
      // Immediately hide elements
      this.isPreparing = true;
      this.isAnimating = false;

      this.$nextTick(() => {
        // Small delay then start animation
        setTimeout(() => {
          this.isPreparing = false;
          this.isAnimating = true;
        }, 30);
      });
    },
    setName(name) {
      switch (name) {
        case "RESERVADO":
          return this.country == 1 ? "Reservado" : "Separado";
        case "PROMESADO":
          return this.country == 1 ? "Promesado" : "Minuta";
        case "ESCRITURADO":
          return this.country == 1 ? "Escriturado" : "Escriturado";
        case "ENTREGADO":
          return this.country == 1 ? "Entregado" : "Entregado";
      }
    },
    isColorLight(color) {
      if (!color) return false;
      // Remove # if present
      const hex = color.replace("#", "");
      // Convert to RGB
      const r = parseInt(hex.substr(0, 2), 16);
      const g = parseInt(hex.substr(2, 2), 16);
      const b = parseInt(hex.substr(4, 2), 16);
      // Calculate luminance
      const luminance = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
      return luminance > 0.8; // Consider light if luminance > 0.8
    },
  },
  computed: {
    customerId() {
      return this.$store.getters.getCustomerData
        ? this.$store.getters.getCustomerData.customer_id
        : null;
    },
    isLightBackground() {
      const menuTextColor =
        this.$store.getters.getCustomerData?.color_menu_text;
      return this.isColorLight(menuTextColor);
    },
  },
};
</script>
<style></style>
